import React, { Component, Children } from "react";

// Styles
import "./styles.scss";

import cx from "classnames";
import { history } from "../../utils/history";
import { currency } from "../../utils/currencyFormat";
import { connect } from "react-redux";
import moment from "moment";
import { fetchWalletTxns } from "../../redux/actions";
const Card = ({ children, className }) => {
  return <div className={cx("card", className)}>{children}</div>;
};
class TxnDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.props.fetchWalletTxns({
      wallet_id: this.props.location.search.split("=")[1],
    });
    document.addEventListener("deviceready", this.onDeviceReady(), false);
  }

  onDeviceReady() {
    window.firebase.analytics().logEvent("landing-txn-details");
  }

  returnTime(time) {
    let hour = time.split(":")[0];
    let min = time.split(":")[1];
    let finalHour =
      hour > 12 ? (hour - 12 > 10 ? hour - 12 : 0 + hour - 12) : hour;
    let postFix = hour > 12 ? "pm" : "am";
    return finalHour + ":" + min + postFix;
  }
  handleBack() {
    history.goBack();
  }
  render() {
    const { state, props } = this;
    let walletTxnsData = props.walletTxnsData.data;
    return (
      <div className="screen txnDetails">
        {walletTxnsData && (
          <>
            <div className="profile d-flex align-center justify-start animated fadeInDown">
              {/* style={{backgroundImage:`linear-gradient(to bottom, ${state.data.profile.backgroundColor}, rgba(84, 106, 142, 0))`}} */}
              <img
                onClick={() => {
                  this.handleBack();
                }}
                src={require("../../assets/back.svg")}
              />
              {/* <div className="user-img">
            <img src={require("../../assets/shop.svg")} />
          </div> */}
              <div className="details">
                <p>{walletTxnsData.wallet_info.wallet_name}!</p>
                <p>
                  <span>balance</span>₹
                  {currency.format(walletTxnsData.wallet_info.current_balance)}
                </p>
              </div>
            </div>
            <Card className="recent-txns">
              <p className="title">transactions</p>
              {walletTxnsData.recent_txns.map((item, index) => {
                return (
                  <div
                    className="txns d-flex justify-between  animated fadeInUp"
                    onClick={() => {
                      // this.handleTxnClick(item.txnId);
                    }}
                    style={{ animationDelay: `0.${index + 2}s` }}
                  >
                    <div className="timestamp txns-card">
                      <p className="date">
                        {moment(item.txn_date).format("DD")}
                      </p>
                      <p className="month">
                        {moment(item.txn_date).format("MMM")}
                      </p>
                      <p className="time">
                        {this.returnTime(moment(item.txn_date).format("hh:mm"))}
                      </p>
                    </div>
                    <div className="details txns-card">
                      <p className="value">
                        {item.txn_type === "LOAD" ? "+" : "-"} ₹
                        {currency.format(item.txn_amount)}
                      </p>
                      <p
                        className="info"
                        style={
                          item.txn_type === "LOAD"
                            ? { color: "#3a955d" }
                            : { color: "#e08f5f" }
                        }
                      >
                        {item.txn_info}
                      </p>
                      {item.txn_cashback_amount + item.bp_bonus_amount > 0 && (
                        item.txn_type === "LOAD" ?
                        <p className="cashback">
                          earned <span>₹{Math.round(currency.format(item.txn_cashback_amount + item.bp_bonus_amount))}</span> cashback
                        </p> :
                        <p className="cashback">
                          redeemed <span>₹{Math.round(currency.format(item.txn_cashback_amount + item.bp_bonus_amount))}</span> cashback
                        </p>
                      )}
                    </div>
                  </div>
                );
              })}
            </Card>
          </>
        )}
      </div>
    );
  }
}

const mapStateToProps = ({ walletTxns }) => ({
  walletTxnsData: walletTxns.data,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch,
  fetchWalletTxns: (data) => dispatch(fetchWalletTxns(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TxnDetails);
